import * as React from 'react';
import { ComponentProps, JSX } from 'react';
import { DragHandleIcon } from '@chakra-ui/icons';
import { Box, Flex } from '@chakra-ui/react';
import { Draggable } from '@hello-pangea/dnd';

export const Drag = ({
  id,
  index,
  children,
  ...props
}: {
  id: string;
  index: number;
} & ComponentProps<typeof Box>): JSX.Element => {
  return (
    <Draggable draggableId={id} index={index}>
      {(provided) => {
        return (
          <Flex ref={provided.innerRef} {...provided.draggableProps} {...props} m={3} alignItems="flex-start" gap={3}>
            <Box {...provided.dragHandleProps} borderRadius="lg" p={2} minW={'40px'}>
              <DragHandleIcon />
            </Box>
            <Box w="100%">{children}</Box>
          </Flex>
        );
      }}
    </Draggable>
  );
};
